export default {
    // namespaced: true,
    state:{
        // 面包屑
        tabList:[
            {
                fullPath: 'wbdp-recharge-config',
                menuName: '充值配置',
                id: '101'
            },
        ]
    },
    mutations:{
        //修改state
        selectMenu(state, val) {
            // 判断添加的数据是否为首页
            if (val.menuName !== JSON.parse(localStorage.getItem('defultTag')).menuName) {
                const index = state.tabList.findIndex(item => item.menuName === val.menuName);
                // 如果不存在
                if (index === -1) {
                    state.tabList.push({
                        fullPath: val.route,
                        menuName: val.menuName,
                        id: val.id
                    });
                }
            }
        },
        closeTag(state,item) {
            const idx = state.tabList.findIndex(v => v.menuName === item.menuName);
            state.tabList.splice(idx, 1);
        }
    },
    actions: {
    },
    modules: {}
}
